import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Router from "vue-router";
import store from "./store/index.js";
import VueWorker from "vue-worker";
import BootstrapVue from "bootstrap-vue";

import firebase from "./helpers/firebaseConfig";

import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/bootstrap-vue/dist/bootstrap-vue.css";
import "../node_modules/firebaseui/dist/firebaseui.css";
import "./App.scss";
// PWA
import "./registerServiceWorker";

Vue.use(BootstrapVue);

Vue.use(Router);
Vue.use(VueWorker);

Vue.config.productionTip = false;
new Vue({
  firebase,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
